/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useCallback } from "react";
import EwaButton2 from "../../../atoms/inputs/EwaButtons/EwaButton/EwaButton2";
import { pagingButtonCss } from "./styles";

export type PagingButtonProps = {
  pageNumber: number;
  onClick: (pageNumber: number) => void;
  disabled: boolean;
};

const PagingButton = ({ pageNumber, onClick, disabled }: PagingButtonProps) => {
  const boundOnClick = useCallback(() => {
    if (!disabled) onClick(pageNumber);
  }, [onClick, pageNumber, disabled]);

  return (
    <EwaButton2
      label={String(pageNumber)}
      disabled={disabled}
      onClick={boundOnClick}
      css={pagingButtonCss}
    />
  );
};

export default PagingButton;
